import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MaintenancePage from '../pages/MaintenancePage';
import LoginVerifyCode from '../pages/LoginVerifyCode';
import ProtectedRoute from '../components/auth/ProtectedRoute';

const MaintenanceRoutes: React.FC = () => (
  <Routes>
    <Route
      path="/login/verify-code"
      element={
        <ProtectedRoute requireAuth={false}>
          <LoginVerifyCode />
        </ProtectedRoute>
      }
    />
    <Route path="/login" element={<Navigate to="/" replace />} />
    <Route path="*" element={<MaintenancePage />} />
  </Routes>
);

export default MaintenanceRoutes;
